import { createClient, Client } from 'graphql-ws';
import { EnvConfig } from '../../envConfig';

export class SubscriptionClientProvider {
  private static instance: Client | undefined;
  private static currentToken: string | undefined;

  private static createInstance(accessToken: string): void {
    this.instance = createClient({
      url: EnvConfig.subscriptionsUrl,
      lazy: true,
      connectionParams: {
        headers: {
          authorization: `Bearer ${accessToken}`,
        },
      },
    });
    this.currentToken = accessToken;
  }

  public static getInstance(accessToken: string): Client {
    // Re-create the client whenever the access token changes (impersonation,
    // token refresh, re-login). The WS connection captures the token in
    // connectionParams at creation time, so a cached singleton keeps
    // subscribing with a stale identity — the server then rejects the
    // subscription ("not authorized to subscribe to <Type> events") because the
    // socket is authenticated as the wrong (e.g. pre-impersonation) account.
    // Previously only a full page reload cleared this static singleton.
    if (!this.instance || this.currentToken !== accessToken) {
      if (this.instance) {
        void this.instance.dispose();
      }
      this.createInstance(accessToken);
    }

    return this.instance as Client;
  }
}
